import { Component, Input, OnInit } from '@angular/core';
import { KmsService } from '../../kms.service';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { DictionaryService } from '../../../../librarys/serves/public/dictionary.service';
import { KmsEnum } from '../../serves/kms-enum';
@Component({
  selector: 'app-instance-record-info-view',
  templateUrl: './instance-record-info-view.component.html',
  styleUrls: ['./instance-record-info-view.component.css']
})
export class InstanceRecordInfoViewComponent implements OnInit {
    // 输入参数：实体id
    @Input() instanceId:string = '';
    // 路由参数
    params = {
        instanceId: '',  // 实体id(用于切换tab导航和新增其他信息时的判断)
        conceptId: '',
        instanceName: '',
        conceptName: '',
    };
    
    // 是否显示加载中
    isLoading = false;

    // 实体基本信息内容
    instanceDetailData: any;

    // 实体标签信息内容
    selectedTags = [];

    // 实体表单结构信息
    baseInfoConfig = [];

    // 其它属性表单结构（如生平、流传、修复等）
    multipleAttribute = []

    // 是否展示底部按钮
    showFooterBtn:boolean = true;

    // 表单控件类型
    formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
    constructor(
        private kmsService: KmsService,
        private dicService: DictionaryService,
        private message: SwMassageBoxService,
    ) { }

    ngOnInit() {
    }

    ngOnChanges(){
        if(this.instanceId){
            this.params.instanceId = this.instanceId;
            this.getInstanceById(this.instanceId);
            this.showFooterBtn = false;
        }
    }

    // 根据实体ID查询实体详细信息
    getInstanceById(id) {
        this.kmsService.getInstanceById(id).subscribe(
            result => {
                if (result.code == 200) {
                    let datas = result.data;
                    this.params.conceptId = datas.conceptId;
                    this.params.conceptName = datas.conceptName;
                    this.instanceDetailData = datas;
                    if (datas.tags) {
                        this.selectedTags = datas.tags;
                    } else {
                        this.selectedTags = [];
                    }
                    this.params.instanceName = datas.instanceName;
                    this.getInstanceFormData(this.params.conceptId);
                }
            }
        )
    }

    // 根据概念id查询属性字段列表
    getInstanceFormData(id) {
        this.kmsService.getAttributeForForm(id).subscribe(
            result => {
                if (result.code == '200') {
                    // 渲染基本信息表格
                    // 获取著录信息配置
                    let commonAttributes = result.data.commonAttributes;
                    let datas = [];
                    commonAttributes.forEach(el => {
                        el.attrChild.forEach(child => {
                            datas.push([child]);
                        })
                    });

                    // 获取复合属性信息配置
                    this.multipleAttribute = result.data.compositeAttributes;  

                    // 当前实体详细包含的三元组数据内容
                    let triples = this.instanceDetailData.attrs;
                    datas.filter((item, index) => {
                        let itemDatas, status = 0;
                        if (item.list) {
                            itemDatas = item.list[0];
                            itemDatas[0].triplesId = itemDatas[0].englishCode;
                            itemDatas[0].id = 0;
                            itemDatas[0].attributeChName = '';
                            itemDatas[0].sourceName = '';
                            status = 1;
                        }  else {
                            itemDatas = item[0];
                            itemDatas.id = 0;
                            itemDatas.triplesId = itemDatas.englishCode;
                            itemDatas.attributeChName = '';
                            itemDatas.sourceName = '';
                            if (itemDatas.dictionryCode) {
                                // 表单属性结构字典存在
                                itemDatas.options = this.dicService.getDictionaryValueOrName(
                                    itemDatas.dictionryCode
                                );
                            }
                        }
                        
                        if (triples && triples.length > 0) {
                            for (let i = 0; i < triples.length; i++) {
                                itemDatas = JSON.parse(JSON.stringify(itemDatas));
                                if (status == 1) {
                                    // 特殊表单结构
                                    if (itemDatas[0].attributeId == triples[i].relationshipId) {
                                        // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                                        if (!itemDatas[0].uuid) {
                                            datas[index].list.splice(0, 1);
                                        }
                                        if (triples[i].dictCode) {
                                            // 特殊表单备注存在
                                            itemDatas[0].attributeChNameOther = triples[i].dictCode;
                                            itemDatas[1].attributeChName = triples[i].dictCode;
                                        }
                                        itemDatas[0].attributeChName = triples[i].attributeValue;
                                        itemDatas[0].sourceName = triples[i].datasource == 'none' ? '' : triples[i].datasource;
                                        itemDatas[0].uuid = triples[i].uuid;
                                        itemDatas[0].triplesId = triples[i].uuid;
                                        itemDatas[0].id = triples[i].sortNum;
                                        datas[index].list.push(itemDatas);
                                    }
                                } else {
                                    // 普通表单结构
                                    if (itemDatas.attributeId == triples[i].relationshipId) {
                                        // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                                        if (!itemDatas.uuid) {
                                            datas[index].splice(0, 1);
                                        }

                                        if (itemDatas.dictionryCode && triples[i].dictCode) {
                                            // 返回数据存在字典值时（下拉数据）
                                            itemDatas.attributeChName = triples[i].dictCode;
                                        } else {
                                            // 表单属性结构字典不存在
                                            if (triples[i].dictCode) {
                                                // 返回数据存在字典值时（特殊字段数据，如时间）
                                            }
                                            itemDatas.attributeChName = triples[i].attributeValue;
                                        }
                                        itemDatas.sourceName = triples[i].datasource == 'none' ? '' : triples[i].datasource;
                                        itemDatas.uuid = triples[i].uuid;
                                        itemDatas.triplesId = triples[i].uuid;
                                        itemDatas.id = triples[i].sortNum;
                                        datas[index].push(itemDatas);
                                    }
                                }
                            }
                        }

                    });
                    // 保存属性结构数据
                    this.baseInfoConfig = datas;
                    console.log(this.baseInfoConfig);
                } else {
                    this.message.waring(result.msg);
                }
            });
    }

    // 根据字典查看文字信息
    getDictionaryName(x, y) {
        if (y) {
            let yDatas: any;
            let datas = [];
            yDatas = y.split(',');
            for (let i = 0; i < x.length; i++) {
                for (let j = 0; j < yDatas.length; j++) {
                    if (x[i].id == yDatas[j]) {
                        datas.push(x[i].text)
                    }
                }
            }
            if (datas.toString()) {
                return datas.toString();
            } else {
                return '不详';
            }
        }
    }
}
